import { useCallback } from "react"
import { environment } from "modules/environments"
import { useDataCompany } from "modules/sites"
import { useFetch } from "utils/fetch"

export const hostMap = {
  // develop: '//10.6.8.46:6379', 現在的但壞了
  // develop: '//10.6.110.66:8083', 以前的
  develop: "https://prospect.dev.gogoro.cc",
  regression: "https://prospect.qa.gogoro.cc",
  staging: "https://prospect.gogoro.cc",
  production: "//prospect.gogoro.com",
  globe_develop: "https://prospect.globe.dev.gogoro.cc",
  globe_regression: "https://prospect.globe.qa.gogoro.cc",
  globe_staging: "https://prospect.globe.gogoro.cc",
  globe_production: "https://prospect.gogoro.com.ph",
}

export const hostName = hostMap[environment]

export const useGetData = (path) => {
  const dataCompany = useDataCompany()
  const { getData } = useFetch(hostName)
  return useCallback(
    (params) =>
      getData(typeof path === "function" ? path(params) : path, params, {
        credentials: "same-origin",
        headers: { "Data-Company": dataCompany },
      }),
    [getData, path, dataCompany],
  )
}
